import moment from "moment-timezone";
import type { UserPreferences } from "../types/user-preferences";
import type { Preferences } from "@smartsuite/types/lib/models/preferences";

export const formatDateByUserPreferences = (
  date: Date,
  timezone: string,
  format: string,
): string => {
  return moment.utc(date).tz(timezone).format(format);
};

export const createDateInUserTimezone = (
  date: Date,
  timezone: string,
): Date => {
  const newDate = moment().tz(timezone);
  newDate.set({
    year: date.getFullYear(),
    month: date.getMonth(),
    date: date.getDate(),
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  });
  newDate.tz("UTC");
  return newDate.toDate();
};
export const convertDateToBrowserTimezone = (
  date: Date,
  timezone: string,
): Date => {
  const dateAutTimezone = moment.utc(date).tz(timezone);
  const newDate = moment();
  newDate.set({
    year: dateAutTimezone.year(),
    month: dateAutTimezone.month(),
    date: dateAutTimezone.date(),
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  });
  return newDate.toDate();
};

export const getTimeFormatByUserPreferences = (
  userPreferences: UserPreferences | Preferences,
): string =>
  userPreferences.locale.time_format === "12h" ? "hh:mma" : "HH:mm";
